// extracted by mini-css-extract-plugin
export default {"card":"styles_card__JJIav","label":"styles_label__F19b+","value":"styles_value__gOlad","cardLinked":"styles_cardLinked__BCTfu"};